import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type UserTab = "dashboard" | "account" | "addresses" | "orders";

export interface UserState {
  activeTab: UserTab;
}

const initialState: UserState = {
  activeTab: "dashboard",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<UserTab>) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setActiveTab } = userSlice.actions;
export default userSlice.reducer;
